import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import {
  CHECKAUTH_QUERY,
  INTERMEDIARY_LIST,
  META_QUERIES,
  VIEW_QUOTE_TW,
} from './queries';
import { Loading,Error } from 'quanta-flows/modules/layout';
import CaptureTwoWheelerDetails from '../capture-details/motor/carSecure';
import { updateMotorQuote } from 'quanta-flows/modules/quote/motor/state';
import { useFetchQuery } from 'quanta-flows';
import { Card, useResponsiveParams, Text } from 'quanta-ui';
import { ClientService,Layout } from 'quanta-flows/modules/layout';
import { GET_DOCUMENTS_INFO } from '../view-proposal-details/queries';

export default function ViewQuoteDetailsCarSecure() {
  const { quote_number } = useParams();
  const [loadingMetaQueries, setLoadingMetaQueries] = useState(false);
  const [errorMetaQueries, setErrorMetaQueries] = useState(null);
  const fetchQuery = useFetchQuery();
  const history = useHistory();
  const reformData = (val, returnType, isString) => {
    return val && val.toString().trim() !== ''
      ? isString === undefined || isString === true
        ? `${val}`
        : val
      : returnType;
  };
  const textSize = useResponsiveParams({
    for_desktop: '3xl',
    for_mobile: '2xl',
    for_iPad: '3xl',
  });

  const {
    loading: loadingMyIntermediaries,
    error: errorMyIntermediaries,
    data: dataMyIntermediaries,
  } = useQuery(INTERMEDIARY_LIST);
  const {
    loading: loadingRole,
    error: errorRole,
    data: dataRole,
  } = useQuery(CHECKAUTH_QUERY, {
    fetchPolicy: 'cache-first',
  });

  const add = (riskCovers) =>{
    /*coverIndexList = covers displayed in Vehicle Page*/ 
    const coverIndexList =['N093891G0088','N093891G0099','N093891G0045','N093891G0090','N093891G0087','N093891G0043','N093891G0088','N093891G0099','N093891G0100','N093891G0045','N093891G0090','N093891G0087','N093891G0043','N093891G0088','N093891G0099','N093891G0045','N093891G0090','N093891G0087','N093891G0043','N093891G0093','N093891G0058','N093891G0051']
    let CoverList={}
    riskCovers?.map((riskCover)=>{
      return riskCover?.covers?.map(
         (cover)=> (cover?.index === coverIndexList.find(((e) => e === cover?.index ))
         ? CoverList[cover?.name]={selected:cover?.selected}:null)
      )
    })?.filter((e) => e);
    return CoverList;
  }
  const { loading, error, data } = useQuery(VIEW_QUOTE_TW, {
    variables: {
      input: {
        quoteNumber: quote_number,
      },
    },
    onCompleted: async (data) => {
      try {
        const metaQuery = fetchQuery({
          query: META_QUERIES,
          variables: {
            productCode: data?.viewQuoteTW?.product?.productCode,
            productType: data?.viewQuoteTW?.productType,
          },
        });
        setLoadingMetaQueries(true);
        const { data: metaQueryData } = await metaQuery;
        const {
          lobProductList,
          getTwoWheelerBusinessType,
          PRD_TotalClaimCountList,
          PRD_PreviousPolicyTermList,
        } = metaQueryData;
        setLoadingMetaQueries(false);
        let uploadedDocsList ;
        if (data?.viewQuoteTW?.quoteNumber) {
          const getUploadedDocsQuery = fetchQuery({
            query: GET_DOCUMENTS_INFO,
            variables: {
              input: {
                proposalNumber: data?.viewQuoteTW?.quoteNumber,
              },
            },
          });
          setLoadingMetaQueries(true);
          let { data: getUploadedDocsData } = await getUploadedDocsQuery;
          
          const { getDocumentsForCustomer } = getUploadedDocsData;
         
          uploadedDocsList = getDocumentsForCustomer;
          setLoadingMetaQueries(false);
        }
        updateMotorQuote({
          quotationNo: data?.viewQuoteTW?.quoteNumber
            ? `${data?.viewQuoteTW?.quoteNumber}`
            : '',
            disableNCB:data?.viewQuoteTW?.disableNCB
            ?true:false,
          intermediaryDetails: {
            code: data?.viewQuoteTW?.intermediaryDetails?.code
              ? `${data?.viewQuoteTW?.intermediaryDetails?.code}`
              : '',
            name: data?.viewQuoteTW?.intermediaryDetails?.name
              ? `${data?.viewQuoteTW?.intermediaryDetails?.name}`
              : '',
            location: data?.viewQuoteTW?.intermediaryDetails?.location
              ? `${data?.viewQuoteTW?.intermediaryDetails?.location}`
              : '',
            fieldUserCode: data?.viewQuoteTW?.intermediaryDetails
              ?.fieldUserCode
              ? `${data?.viewQuoteTW?.intermediaryDetails?.fieldUserCode}`
              : '',
            fieldUserName: data?.viewQuoteTW?.intermediaryDetails
              ?.fieldUserName
              ? `${data?.viewQuoteTW?.intermediaryDetails?.fieldUserName}`
              : '',
          },
          quotationStatus: data?.viewQuoteTW?.quoteStatus
            ? `${data?.viewQuoteTW?.quoteStatus}`
            : '',
          quoteCreationDate: data?.viewQuoteTW?.quoteCreationDate
            ? `${data?.viewQuoteTW?.quoteCreationDate}`
            : '',
          productType: data?.viewQuoteTW?.productType
            ? `${data?.viewQuoteTW?.productType}`
            : '',
          productVariant: data?.viewQuoteTW?.productVariant
            ? `${data?.viewQuoteTW?.productVariant}`
            : data?.viewQuoteTW?.product?.productName
            ? `${data?.viewQuoteTW?.product?.productName}`
            : '',
          productCode:data?.viewQuoteTW?.product?.productCode,
          proposalNumber: data?.viewQuoteTW?.proposalNumber
            ? `${data?.viewQuoteTW?.proposalNumber}`
            : '',
          productTypeValue: lobProductList
            ?.find(
              (lpl) =>
                lpl?.lob_code?.toString()?.toLowerCase() ===
                data?.viewQuoteTW?.lob?.lobCode
                  ?.toString()
                  ?.toLowerCase(),
            )
            ?.products?.find(
              (prd) =>
                prd?.product_code?.toString()?.toLowerCase() ===
                data?.viewQuoteTW?.product?.productCode
                  ?.toString()
                  ?.toLowerCase(),
            )
            ?.product_types?.find(
              (p) =>
                p?.value?.toLowerCase() ===
                data?.viewQuoteTW?.productType?.toLowerCase(),
            )?.code,
          businessType: data?.viewQuoteTW?.businessType
            ? `${data?.viewQuoteTW?.businessType}`
            : '',
          businessTypeValue: getTwoWheelerBusinessType?.value
            ? `${getTwoWheelerBusinessType?.value}`
            : '',
          regNo: data?.viewQuoteTW?.vehicleDetails?.registrationNumber
            ? `${data?.viewQuoteTW?.vehicleDetails?.registrationNumber}`
            : '',
          isRegNoVerified: true,
          isPrevClaimsAvailable:
            getTwoWheelerBusinessType?.value?.toLowerCase() ===
            'roll over'
              ? true
              : false,
          isPrevInsuranceAvailable:
            getTwoWheelerBusinessType?.value?.toLowerCase() ===
            'roll over'
              ? true
              : false,
          mode: '',
          vehicleRegNo: {
            part1: `${
              data?.viewQuoteTW?.vehicleDetails?.registrationNumber
                ? data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                    0,
                    2,
                  )
                : ''
            }`,
            part2: `${
              data?.viewQuoteTW?.vehicleDetails?.registrationNumber
                ? data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                    2,
                    4,
                  )
                : ''
            }`,
            part3: `${
              data?.viewQuoteTW?.vehicleDetails?.registrationNumber
                ? data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                  2,
                  4,
                  )?.toLowerCase() === 'bh'
                  ?  data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                    4,
                    8,
                  )
                  : data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.length=== 8     // SADivya IM241121/23693 - set empty value for 3RD block non mandatory case
                    ? ''
                    : data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(6, 7)?.match(/^[a-zA-Z]/)
                      ? data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(4, 7)?.toUpperCase()
                      : data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                        4,
                        6,
                      )
                : ''
            }`,
            part4: `${
              data?.viewQuoteTW?.vehicleDetails?.registrationNumber
                ? data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                  2,
                  4,
                  )?.toLowerCase() === 'bh'
                  ? data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                    8,
                    10,
                  )
                  : data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.length=== 8     // SADivya IM241121/23693 - 3RD block non mandatory case
                    ? data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(4,8)
                    : data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(6, 7)?.match(/^[a-zA-Z]/)
                      ? data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(7, 11)
                      : data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                        6,
                        10,
                      )
                : ''
            }`,
            bhseries : 
              data?.viewQuoteTW?.vehicleDetails?.registrationNumber
                ? data?.viewQuoteTW?.vehicleDetails?.registrationNumber?.slice(
                    2,
                    4,
                  )?.toLowerCase() === 'bh' ? true : false 
                : false
            ,
          },
          suggestedIDV:
            data?.viewQuoteTW?.insuredDeclaredValue?.suggestedIDV !==
            null
              ? `${data?.viewQuoteTW?.insuredDeclaredValue?.suggestedIDV}`
              : '',
          minSuggestedIDV:
            data?.viewQuoteTW?.insuredDeclaredValue
              ?.minSuggestedIDV !== null
              ? `${data?.viewQuoteTW?.insuredDeclaredValue?.minSuggestedIDV}`
              : '',
          maxSuggestedIDV:
            data?.viewQuoteTW?.insuredDeclaredValue
              ?.maxSuggestedIDV !== null
              ? `${data?.viewQuoteTW?.insuredDeclaredValue?.maxSuggestedIDV}`
              : '',
          changedIDV:
            data?.viewQuoteTW?.insuredDeclaredValue?.firstYearIDV !==
            null
              ? `${data?.viewQuoteTW?.insuredDeclaredValue?.firstYearIDV}`
              : '',
          adjustmentIRF:
            data?.viewQuoteTW?.irf1 !== null
              ? `${data?.viewQuoteTW?.irf1}`
              : '0',
          adjustmentIRF2:
              data?.viewQuoteTW?.adjustmentIRF2 !== null
                ? `${data?.viewQuoteTW?.adjustmentIRF2}`
                : '0',
          IRF2comments:
                data?.viewQuoteTW?.IRF2comments !== null
                  ? `${data?.viewQuoteTW?.IRF2comments}`
                  : '0',
          irfPctMin:
            data?.viewQuoteTW?.insuredDeclaredValue?.irfPctMin !==
            null
              ? `${data?.viewQuoteTW?.insuredDeclaredValue?.irfPctMin}`
              : '',
          irfPctMax:
            data?.viewQuoteTW?.insuredDeclaredValue?.irfPctMax !==
            null
              ? `${data?.viewQuoteTW?.insuredDeclaredValue?.irfPctMax}`
              : '',
          idvPctMin:
            data?.viewQuoteTW?.insuredDeclaredValue?.idvPctMin !==
            null
              ? `${data?.viewQuoteTW?.insuredDeclaredValue?.idvPctMin}`
              : '',
          idvPctMax:
            data?.viewQuoteTW?.insuredDeclaredValue?.idvPctMax !==
            null
              ? `${data?.viewQuoteTW?.insuredDeclaredValue?.idvPctMax}`
              : '',
          anyPreviousPolicyforVehicleTaken: data?.viewQuoteTW
            ?.isPreviousPolicy
            ? 'Yes'
            : 'No',
          isVehicleDetailsAvailable: data?.viewQuoteTW?.vehicleDetails
            ?.make?.code
            ? true
            : false,
          policyCoverType: data?.viewQuoteTW?.previousPolicy
            ?.coverType
            ? `${data?.viewQuoteTW?.previousPolicy?.coverType}`
            : '',
          policyTenure: data?.viewQuoteTW?.previousPolicy
            ?.policyTenure
            ? `${data?.viewQuoteTW?.previousPolicy?.policyTenure}`
            : '',
          policyTenureValue: PRD_PreviousPolicyTermList?.find(
            (pT) =>
              pT?.code?.toLowerCase() ===
              data?.viewQuoteTW?.previousPolicy?.policyTenure?.toLowerCase(),
          )?.value,
          policyStartDate: data?.viewQuoteTW?.previousPolicy
            ?.startDate
            ? `${data?.viewQuoteTW?.previousPolicy?.startDate}`
            : '',
          policyExpiryDate: data?.viewQuoteTW?.previousPolicy
            ?.expiryDate
            ? `${data?.viewQuoteTW?.previousPolicy?.expiryDate}`
            : '',
          totalClaimCount: data?.viewQuoteTW?.previousClaims
            ?.totalClaimCount
            ? `${data?.viewQuoteTW?.previousClaims?.totalClaimCount}`
            : '',
          totalClaimCountValue: PRD_TotalClaimCountList?.find(
            (claimCount) =>
              claimCount?.code?.toLowerCase() ===
              data?.viewQuoteTW?.previousClaims?.totalClaimCount?.toLowerCase(),
          )?.value,
          noOfClaimsOneYear:
            data?.viewQuoteTW?.previousClaims?.claimsInYear1,
          noOfClaimsTwoYears:
            data?.viewQuoteTW?.previousClaims?.claimsInYear2,
          noOfClaimsThreeYears:
            data?.viewQuoteTW?.previousClaims?.claimsInYear3,
          totalClaimAmount:
            data?.viewQuoteTW?.previousClaims?.totalClaimAmount,
          previousYearNCBSlab:
            data?.viewQuoteTW?.previousClaims?.prevNCBSlab,
          financerName: data?.viewQuoteTW?.financerName,
          vehicleIsOwnedBy: data?.viewQuoteTW?.customer?.cust_type?.code=='Organisation'
          ?'Corporate'
          :`${
            data?.viewQuoteTW?.customer?.cust_type?.code
              ? `${data?.viewQuoteTW?.customer?.cust_type?.code}`
              : ''
          }${
            data?.viewQuoteTW?.customer?.indv_detail?.gender?.code
              ? `#${data?.viewQuoteTW?.customer?.indv_detail?.gender?.code}`
              : ''
          }`,
          vehicleOwnerTypeAndGender: {
            gender: data?.viewQuoteTW?.customer?.indv_detail?.gender
              ?.code
              ? `${data?.viewQuoteTW?.customer?.indv_detail?.gender?.code}`
              : '',
            organisationType:
              data?.viewQuoteTW?.customer?.cust_type?.code,
          },
          pincode: data?.viewQuoteTW?.location?.pincode
            ? `${data?.viewQuoteTW?.location?.pincode}`
            : '',
          state: data?.viewQuoteTW?.location?.state
            ? `${data?.viewQuoteTW?.location?.state}`
            : '',
          getAdditionalCreditScore: data?.viewQuoteTW
            ?.creditScoreDetials?.discountOpted
            ? 'Yes'
            : 'No',
          idProofType: data?.viewQuoteTW?.creditScoreDetials
            ?.idProofType
            ? `${data?.viewQuoteTW?.creditScoreDetials?.idProofType}`
            : '',
          idProofNumber: data?.viewQuoteTW?.creditScoreDetials
            ?.idProofType
            ? `${data?.viewQuoteTW?.creditScoreDetials?.idProofNumber}`
            : '',
          cs_proposer_first_name :data?.viewQuoteTW?.creditScoreDetials?.firstName
            ? `${data?.viewQuoteTW?.creditScoreDetials?.firstName}`
            : '',
          cs_proposer_last_name : data?.viewQuoteTW?.creditScoreDetials?.lastName
            ? `${data?.viewQuoteTW?.creditScoreDetials?.lastName}`
            : '',
          cs_proposer_mobileNo :data?.viewQuoteTW?.creditScoreDetials?.mobileNo
            ? `${data?.viewQuoteTW?.creditScoreDetials?.mobileNo}`
            : '',
          cs_proposerDOB: data?.viewQuoteTW?.creditScoreDetials?.proposerDOB
            ? `${data?.viewQuoteTW?.creditScoreDetials?.proposerDOB}`
            : '',
          creditScore: data?.viewQuoteTW?.creditScoreDetials?.creditScore
            ? `${data?.viewQuoteTW?.creditScoreDetials?.creditScore}`
            : null,
          voluntaryDeductibleAmount:
            data?.viewQuoteTW?.voluntaryDeductibleAmt !== null
              ? `${data?.viewQuoteTW?.voluntaryDeductibleAmt}`
              : '',
	  //SA975  
          NCB:
              data?.viewQuoteTW?.NCB !== null
                ? `${data?.viewQuoteTW?.NCB}`
                : '',
	  //EA975
          make: {
            code: data?.viewQuoteTW?.vehicleDetails?.make?.code
              ? `${data?.viewQuoteTW?.vehicleDetails?.make?.code}`
              : '',
            value: data?.viewQuoteTW?.vehicleDetails?.make?.value
              ? `${data?.viewQuoteTW?.vehicleDetails?.make?.value}`
              : '',
          },
          model: {
            code: data?.viewQuoteTW?.vehicleDetails?.model?.code
              ? `${data?.viewQuoteTW?.vehicleDetails?.model?.code}`
              : '',
            value: data?.viewQuoteTW?.vehicleDetails?.model?.value
              ? `${data?.viewQuoteTW?.vehicleDetails?.model?.value}`
              : '',
          },
          variant: {
            code: data?.viewQuoteTW?.vehicleDetails?.variant?.code
              ? `${data?.viewQuoteTW?.vehicleDetails?.variant?.code}`
              : '',
            value: data?.viewQuoteTW?.vehicleDetails?.variant?.value
              ? `${data?.viewQuoteTW?.vehicleDetails?.variant?.value}`
              : '',
          },
          fuelType: data?.viewQuoteTW?.vehicleDetails?.fuelType
            ? `${data?.viewQuoteTW?.vehicleDetails?.fuelType}`
            : '',
          seatingCapacity: data?.viewQuoteTW?.vehicleDetails
            ?.seatingCapacity
            ? `${data?.viewQuoteTW?.vehicleDetails?.seatingCapacity}`
            : '',
          cubeCapacity: data?.viewQuoteTW?.vehicleDetails
            ?.cubicCapacity
            ? `${data?.viewQuoteTW?.vehicleDetails?.cubicCapacity}`
            : '',
          segmentType: data?.viewQuoteTW?.vehicleDetails
          ?.segmentType
          ? `${data?.viewQuoteTW?.vehicleDetails?.segmentType}`
          : '',
          yearOfManufacture: data?.viewQuoteTW?.vehicleDetails
            ?.manufactureYear
            ? `${data?.viewQuoteTW?.vehicleDetails?.manufactureYear}`
            : '',
          dateOfReg: data?.viewQuoteTW?.vehicleDetails
            ?.regPurchaseDate
            ? `${data?.viewQuoteTW?.vehicleDetails?.regPurchaseDate}`
            : '',
          rtoLocationCode:
            data?.viewQuoteTW?.vehicleDetails?.rto?.rtoLocCode ||
            data?.viewQuoteTW?.rtoDetails?.rtoLocCode,
          rtoLocationDesc:
            data?.viewQuoteTW?.vehicleDetails?.rto?.rtoLocDesc ||
            data?.viewQuoteTW?.rtoDetails?.rtoLocDesc,
          rtoAuthorityCode:
            data?.viewQuoteTW?.vehicleDetails?.rto?.rtoAuthCode ||
            data?.viewQuoteTW?.rtoDetails?.rtoAuthCode,
          engineNo: data?.viewQuoteTW?.vehicleDetails?.engineNumber,
          chasisNo: data?.viewQuoteTW?.vehicleDetails?.chasisNumber,
          financerName:
            data?.viewQuoteTW?.vehicleDetails?.financerName ||
            data?.viewQuoteTW?.financerName,
            TP_Policy_Tenure: data?.viewQuoteTW?.TP_Policy_Tenure
            ? `${data?.viewQuoteTW?.TP_Policy_Tenure}`
            : '',
            TP_Start_Date: data?.viewQuoteTW?.TP_Start_Date
            ? `${data?.viewQuoteTW?.TP_Start_Date}`
            : '',
            TP_End_Date: data?.viewQuoteTW?.TP_End_Date
            ? `${data?.viewQuoteTW?.TP_End_Date}`
            : '',
          prevInsurance: {
            insurerName: data?.viewQuoteTW?.previousPolicy
              ?.insurerName
              ? `${data?.viewQuoteTW?.previousPolicy?.insurerName}`
              : '',
            policyNumber: data?.viewQuoteTW?.previousPolicy
              ?.policyNumber
              ? `${data?.viewQuoteTW?.previousPolicy?.policyNumber}`
              : '',
            expiryDate: data?.viewQuoteTW?.previousPolicy?.expiryDate
              ? `${data?.viewQuoteTW?.previousPolicy?.expiryDate}`
              : '',
            startDate: data?.viewQuoteTW?.previousPolicy?.startDate
              ? `${data?.viewQuoteTW?.previousPolicy?.startDate}`
              : '',
            coverType: data?.viewQuoteTW?.previousPolicy?.coverType
              ? `${data?.viewQuoteTW?.previousPolicy?.coverType}`
              : '',
            policyTenure: data?.viewQuoteTW?.previousPolicy
              ?.policyTenure
              ? `${data?.viewQuoteTW?.previousPolicy?.policyTenure}`
              : '',
          },
          premiumData: {
            idv1: data?.viewQuoteTW?.premiumBreakup?.idv1
              ? `${data?.viewQuoteTW?.premiumBreakup?.idv1}`
              : '',
            idv2: data?.viewQuoteTW?.premiumBreakup?.idv2
              ? `${data?.viewQuoteTW?.premiumBreakup?.idv2}`
              : '',
            idv3: data?.viewQuoteTW?.premiumBreakup?.idv3
              ? `${data?.viewQuoteTW?.premiumBreakup?.idv3}`
              : '',
            tenure: data?.viewQuoteTW?.premiumBreakup?.tenure
              ? `${data?.viewQuoteTW?.premiumBreakup?.tenure}`
              : '',
            netODPremium:
              data?.viewQuoteTW?.premiumBreakup?.netODPremium !== null
                ? data?.viewQuoteTW?.premiumBreakup?.netODPremium
                : null,
            netTPPremium:
              data?.viewQuoteTW?.premiumBreakup?.netTPPremium !== null
                ? data?.viewQuoteTW?.premiumBreakup?.netTPPremium
                : null,
            loadingDiscount:
              data?.viewQuoteTW?.premiumBreakup?.loadingDiscount !==
              null
                ? data?.viewQuoteTW?.premiumBreakup?.loadingDiscount
                : null,
            netPremium:
              data?.viewQuoteTW?.premiumBreakup?.netPremium !== null
                ? data?.viewQuoteTW?.premiumBreakup?.netPremium
                : null,
            gst:
              data?.viewQuoteTW?.premiumBreakup?.gst !== null
                ? data?.viewQuoteTW?.premiumBreakup?.gst
                : null,
            stampDuty:
              data?.viewQuoteTW?.premiumBreakup?.stampDuty !== null
                ? data?.viewQuoteTW?.premiumBreakup?.stampDuty
                : null,
            totalPremium:
              data?.viewQuoteTW?.premiumBreakup?.totalPremium !== null
                ? data?.viewQuoteTW?.premiumBreakup?.totalPremium
                : null,
            loading:
              data?.viewQuoteTW?.premiumBreakup?.loading !== null &&
              data?.viewQuoteTW?.premiumBreakup?.loading?.length > 0
                ? data?.viewQuoteTW?.premiumBreakup?.loading
                : [],
            discount:
              data?.viewQuoteTW?.premiumBreakup?.discount !== null &&
              data?.viewQuoteTW?.premiumBreakup?.discount?.length > 0
                ? data?.viewQuoteTW?.premiumBreakup?.discount
                : [],
            vehicleAge: data?.viewQuoteTW?.vehicleDetails?.vehicleAge
              ? `${data?.viewQuoteTW?.vehicleDetails?.vehicleAge}`
              : '',
            claimFreeYear: data?.viewQuoteTW?.premiumBreakup
              ?.claimFreeYear
              ? `${data?.viewQuoteTW?.premiumBreakup?.claimFreeYear}`
              : '',
            creditScore: data?.viewQuoteTW?.premiumBreakup
              ?.creditScore
              ? `${data?.viewQuoteTW?.premiumBreakup?.creditScore}`
              : null ,
	    //SA975
              NCB:
              data?.viewQuoteTW?.premiumBreakup?.NCB !== null
                ? `${data?.viewQuoteTW?.premiumBreakup?.NCB}`
                : '',
	    //EA975
              quotePdf: data?.viewQuoteTW?.quotePdf
                  ? data?.viewQuoteTW?.quotePdf : '',
              clutchProtSI: data?.viewQuoteTW?.premiumBreakup?.clutchProtSI !== null
                ? data?.viewQuoteTW?.premiumBreakup?.clutchProtSI
                : null,
              clutchProtRate: data?.viewQuoteTW?.premiumBreakup?.clutchProtRate !== null
                ? data?.viewQuoteTW?.premiumBreakup?.clutchProtRate
                : null,
              clutchProtPremium: data?.viewQuoteTW?.premiumBreakup?.clutchProtPremium !== null
                ? data?.viewQuoteTW?.premiumBreakup?.clutchProtPremium
                : null,
          },
          customer: {
            customerType:
              data?.viewQuoteTW?.customer?.cust_type?.code,
            is_blackListed:
            data?.viewQuoteTW?.customer?.is_blackListed
            ?data?.viewQuoteTW?.customer?.is_blackListed:false,
            id: data?.viewQuoteTW?.customer?.cust_number,
            emailID: reformData(
              data?.viewQuoteTW?.customer?.contact?.email,
              '',
            ),
            mobileNo: reformData(
              data?.viewQuoteTW?.customer?.contact?.mobile,
              '',
            ),
            phoneNo: reformData(
              data?.viewQuoteTW?.customer?.contact?.telephone,
              '',
            ),
            faxNo: reformData(
              data?.viewQuoteTW?.customer?.contact?.fax_number,
              '',
            ),
            altPhoneNo: reformData(
              data?.viewQuoteTW?.customer?.contact?.alt_telephone,
              '',
            ),
            altMobileNo: reformData(
              data?.viewQuoteTW?.customer?.contact?.alt_mobile,
              '',
            ),
            title: reformData(
              data?.viewQuoteTW?.customer?.indv_detail?.title?.code,
              '',
            ),
            gender: reformData(
              data?.viewQuoteTW?.customer?.indv_detail?.gender?.code,
              '',
            ),
            proposerDOB: reformData(
              data?.viewQuoteTW?.customer?.indv_detail?.date_of_birth,
              '',
            ),
            firstName: reformData(
              data?.viewQuoteTW?.customer?.indv_detail?.first_name,
              '',
            ),
            middleName: reformData(
              data?.viewQuoteTW?.customer?.indv_detail?.middle_name,
              '',
            ),
            fullName: reformData(
              data?.viewQuoteTW?.customer?.indv_detail?.full_name,
              '',
            ),
            lastName: reformData(
              data?.viewQuoteTW?.customer?.indv_detail?.surname,
              '',
            ),
            nationality: reformData(
              data?.viewQuoteTW?.customer?.indv_detail?.nationality
                ?.code,
              '',
            ),
            occupation: reformData(
              data?.viewQuoteTW?.customer?.indv_detail?.occupation
                ?.code,
              '',
            ),
            maritalStatus: reformData(
              data?.viewQuoteTW?.customer?.indv_detail?.marital_status
                ?.code,
              '',
            ),
            panNumber: reformData(
              data?.viewQuoteTW?.customer?.indv_detail
                ?.pan_card_number,
              '',
            ),
            idProofType: reformData(
              data?.viewQuoteTW?.customer?.indv_detail?.id_proof_type
                ?.code,
              '',
            ),
            idProofNumber: reformData(
              data?.viewQuoteTW?.customer?.indv_detail
                ?.id_proof_number,
              '',
            ),
            gstNumber: reformData(
              data?.viewQuoteTW?.customer?.indv_detail?.gst_number ||
                data?.viewQuoteTW?.customer?.org_detail?.gst_number,
              '',
            ),
            employeeNumber: reformData(
              data?.viewQuoteTW?.customer?.indv_detail
                ?.employeeNumber,
              '',
            ),
            orgName: reformData(
              data?.viewQuoteTW?.customer?.org_detail?.org_name,
              '',
            ),
            orgType: reformData(
              data?.viewQuoteTW?.customer?.org_detail?.org_type?.code,
              '',
            ),
            contactName: reformData(
              data?.viewQuoteTW?.customer?.org_detail?.contact_name,
              '',
            ),
            regNumber: reformData(
              data?.viewQuoteTW?.customer?.org_detail?.reg_number,
              '',
            ),
            contact_mob: reformData(
              data?.viewQuoteTW?.customer?.org_detail?.contact_mob,
              '',
            ),
            contact_email: reformData(
              data?.viewQuoteTW?.customer?.org_detail?.contact_email,
              '',), 
            permAddressLine1: reformData(
              data?.viewQuoteTW?.customer?.permanent_address
                ?.address_line1,
              '',
            ),
            permAddressLine2: reformData(
              data?.viewQuoteTW?.customer?.permanent_address
                ?.address_line2,
              '',
            ),
            permAddressLine3: reformData(
              data?.viewQuoteTW?.customer?.permanent_address
                ?.address_line3,
              '',
            ),
            permLandmark: reformData(
              data?.viewQuoteTW?.customer?.permanent_address?.land_mark,
              '',
            ),
            permPincode: reformData(
              data?.viewQuoteTW?.customer?.permanent_address?.pin_code,
              '',
            ),
            permCityTownVillage: reformData(
              data?.viewQuoteTW?.customer?.permanent_address?.city,
              '',
            ),
            permDistrict: reformData(
              data?.viewQuoteTW?.customer?.permanent_address?.district,
              '',
            ),
            permState: reformData(
              data?.viewQuoteTW?.customer?.permanent_address?.state,
              '',
            ),
            permCommAddressYN: data?.viewQuoteTW?.customer
              ?.comm_equal_perm
              ? true
              : false,
            commAddressLine1: reformData(
              data?.viewQuoteTW?.customer?.communication_address
                ?.address_line1,
              '',
            ),
            commAddressLine2: reformData(
              data?.viewQuoteTW?.customer?.communication_address
                ?.address_line2,
              '',
            ),
            commAddressLine3: reformData(
              data?.viewQuoteTW?.customer?.communication_address
                ?.address_line3,
              '',
            ),
            commLandmark: reformData(
              data?.viewQuoteTW?.customer?.communication_address
                ?.land_mark,
              '',
            ),
            commPincode: reformData(
              data?.viewQuoteTW?.customer?.communication_address
                ?.pin_code,
              '',
            ),
            commCityTownVillage: reformData(
              data?.viewQuoteTW?.customer?.communication_address?.city,
              '',
            ),
            commDistrict: reformData(
              data?.viewQuoteTW?.customer?.communication_address
                ?.district,
              '',
            ),
            commState: reformData(
              data?.viewQuoteTW?.customer?.communication_address?.state,
              '',
            ),
          },
          customerMeta: {
            crn: reformData(
              data?.viewQuoteTW?.customer?.cust_ref_number,
              '',
            ),
            ifscCode: reformData(
              data?.viewQuoteTW?.customer?.bank_detail?.ifsc_code,
              '',
            ),
            bankName: reformData(
              data?.viewQuoteTW?.customer?.bank_detail?.name,
              '',
            ),
            branchName: reformData(
              data?.viewQuoteTW?.customer?.bank_detail?.branch_name,
              '',
            ),
            bankAcno: reformData(
              data?.viewQuoteTW?.customer?.bank_detail?.acc_number,
              '',
            ),
            accountHolderName: reformData(
              data?.viewQuoteTW?.customer?.bank_detail?.acc_holder,
              '',
            ),
            micrCode: reformData(
              data?.viewQuoteTW?.customer?.bank_detail?.micr_code,
              '',
            ),
            branchAddress: reformData(
              data?.viewQuoteTW?.customer?.bank_detail
                ?.branch_address,
              '',
            ),
          },
          isPremiumCalculating: false,
          tenure: data?.viewQuoteTW?.tenure
            ? `${data?.viewQuoteTW?.tenure}`
            : '',
          coverData: {
            addOnCovers: data?.viewQuoteTW?.riskCovers,
            rawRiskData: [],
          },
          addOnCovers: add(data?.viewQuoteTW?.riskCovers),
          NCB: data?.viewQuoteTW?.NCB,//SA975
          isQuoteSavingWOCust: data?.viewQuoteTW?.isQuoteSavingWOCust,
          QuoteSavingWOCustIndex: data?.viewQuoteTW?.QuoteSavingWOCustIndex,
          documentDetails : uploadedDocsList?.length > 0 ? uploadedDocsList : [], 
          policy:{
            startDate: data?.viewQuoteTW?.policy?.startDate,
            expiryDate: data?.viewQuoteTW?.policy?.expiryDate,
          },
          zoopCustDtls: {
            custName: data?.viewQuoteTW?.vehicleDetails?.zoopCustDtls?.custName,
            custContactNo: data?.viewQuoteTW?.vehicleDetails?.zoopCustDtls?.custContactNo,
            custAddress: data?.viewQuoteTW?.vehicleDetails?.zoopCustDtls?.custAddress,
            custEmail: data?.viewQuoteTW?.vehicleDetails?.zoopCustDtls?.custEmail,
            custPincode: data?.viewQuoteTW?.vehicleDetails?.zoopCustDtls?.custPincode,
          },
        });
      } catch (error) {
        setLoadingMetaQueries(false);
        setErrorMetaQueries(error?.message);
      }
    },
  });

  return loading ||
    loadingMetaQueries ||
    loadingMyIntermediaries ||
    loadingRole ? (
    <Loading />
  ) : error ||
    errorMetaQueries ||
    errorMyIntermediaries ||
    errorRole ? (
    <Error
      error={{
        message: `There was an issue fetching the Quote Details`,
      }}
    />
  ) : data &&
    dataMyIntermediaries?.myIntermediaries?.find(
      (myIntermediary) =>
        myIntermediary?.intermediaryCode
          ?.toString()
          ?.toLowerCase() ===
        data?.viewQuoteTW?.intermediaryDetails?.code
          ?.toString()
          ?.toLowerCase(),
    ) &&
    (dataRole.checkAuth.role.roleName?.toString()?.toLowerCase() !==
      'underwriter' ||
      (dataRole.checkAuth.role.roleName?.toString()?.toLowerCase() ===
        'underwriter' &&
        [
          'pending uw approval',
          'underwriter approved',
          'underwriter rejected',
        ]?.includes(
          data?.viewQuoteTW?.status?.toString()?.toLowerCase(),
        ))) ? (
    <CaptureTwoWheelerDetails
      productName={data.viewQuoteTW.product.productName}
      productCode={data.viewQuoteTW.product.productCode}
      lobCode={data.viewQuoteTW.lob.lobCode}
      quoteNumber={quote_number}
      breadcrumbNav={['Quote', 'View Quote']}
    />
  ) : data &&
    !dataMyIntermediaries?.myIntermediaries?.find(
      (myIntermediary) =>
        myIntermediary?.intermediaryCode
          ?.toString()
          ?.toLowerCase() ===
        data?.viewQuoteTW?.intermediaryDetails?.code
          ?.toString()
          ?.toLowerCase(),
    ) ? (
    <Layout
      nav={['Quote', 'View Quote']}
      service_type={ClientService}
      title={`Your ${data?.viewQuoteTW?.product?.productName} Quote`}
    >
      <Card className="h-screen" severity={`error`}>
        <Text
          severity={'error'}
          className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
        >
          Access denied.You are not allowed to view quote belonging to
          another intermediary.
        </Text>
      </Card>
    </Layout>
  ) : dataRole.checkAuth.role.roleName?.toString()?.toLowerCase() ===
      'underwriter' &&
    ![
      'pending uw approval',
      'underwriter approved',
      'underwriter rejected',
    ]?.includes(
      data?.viewQuoteTW?.status?.toString()?.toLowerCase(),
    ) ? (
    <Layout
      nav={['Quote', 'View Quote']}
      service_type={ClientService}
      title={`Your ${data?.viewQuoteTW?.product?.productName} Quote`}
    >
      <Card className="h-screen" severity={`error`}>
        <Text
          severity={'error'}
          className={`w-full h-full text-center text-${textSize} flex items-center justify-center`}
        >
          Quote is invalid or not belonging to UW approved, UW
          rejected or pending for UW approval
        </Text>
      </Card>
    </Layout>
  ) : null;
}
